/**
 * 金額進位法（header write：`rounding_mode`）。
 * 後端省略／非法值等同 HALF_UP；前端 Create／Edit 可強制請選擇。
 */

export const ROUNDING_MODE = {
  UP: 'UP',
  DOWN: 'DOWN',
  HALF_UP: 'HALF_UP',
};

/** UI／write options：四捨五入／無條件進位／無條件捨去 */
export const ROUNDING_MODE_OPTIONS = [
  { value: ROUNDING_MODE.HALF_UP, label: '四捨五入' },
  { value: ROUNDING_MODE.UP, label: '無條件進位' },
  { value: ROUNDING_MODE.DOWN, label: '無條件捨去' },
];

const ALLOWED = new Set(Object.values(ROUNDING_MODE));

/**
 * @param {unknown} value
 * @param {string} [fallback='HALF_UP']
 * @returns {string}
 */
export function resolveRoundingMode(value, fallback = ROUNDING_MODE.HALF_UP) {
  if (value === '' || value == null) {
    return fallback;
  }
  return ALLOWED.has(value) ? value : fallback;
}

/**
 * Write／表單：僅回傳合法 enum；空／非法為 null（不偷送 HALF_UP）。
 * @param {unknown} value
 * @returns {string | null}
 */
export function pickRoundingMode(value) {
  if (value === '' || value == null) {
    return null;
  }
  return ALLOWED.has(value) ? value : null;
}
